module.exports = "/images/embed.png?02aef456e3a55750717c8870f777fef4";